/** @format */
import { Action, createReducer, on } from '@ngrx/store';
import {
  HomrBundleSpot,
  HomrGTGTContent,
  HomrScheduleContent,
  IHomrBanner,
  IHomrRichContent,
  IHomrSpot,
} from '@shared/data-access/interfaces';
import {
  homrBannerSet,
  homrBundleContentSet,
  homrContentSet,
  homrInStoreServicesSet,
  homrRichContentSet,
  homrStateReset,
  setHomrGTGTContent,
  setHomrScheduleContent,
} from './homr.actions';

import { HomrInStoreServices } from '@shared/homr/data-access';

export interface HomrState {
  homrBanner: IHomrBanner | null;
  homrBundleContent: HomrBundleSpot | null;
  homrContent: IHomrSpot[] | null;
  homrGTGTContent: HomrGTGTContent | null;
  homrInStoreServices: HomrInStoreServices | null;
  homrRichContent: IHomrRichContent | null;
  homrScheduleContent: HomrScheduleContent | null;
}

export const initHomrState: HomrState = {
  homrBanner: null,
  homrBundleContent: null,
  homrContent: null,
  homrGTGTContent: null,
  homrInStoreServices: null,
  homrRichContent: null,
  homrScheduleContent: null,
};

export const homrReducers = createReducer(
  initHomrState,
  on(setHomrScheduleContent, (state, { homrScheduleContent }) => ({
    ...state,
    homrScheduleContent,
  })),
  on(setHomrGTGTContent, (state, { homrGTGTContent }) => ({
    ...state,
    homrGTGTContent,
  })),
  on(homrBannerSet, (state, { homrBanner }) => ({
    ...state,
    homrBanner,
  })),
  on(homrBundleContentSet, (state, { homrBundleContent }) => ({
    ...state,
    homrBundleContent,
  })),
  on(homrContentSet, (state, { homrContent }) => ({
    ...state,
    homrContent,
  })),
  on(homrInStoreServicesSet, (state, { homrInStoreServices }) => ({
    ...state,
    homrInStoreServices,
  })),
  on(homrRichContentSet, (state, { homrRichContent }) => ({
    ...state,
    homrRichContent,
  })),
  on(homrStateReset, () => initHomrState),
);

// export for module import
export function homrReducer(state: HomrState | undefined, action: Action): HomrState {
  return homrReducers(state, action);
}
